import { render, staticRenderFns } from "./BestUploadDlg.vue?vue&type=template&id=c714a70e&scoped=true"
import script from "./BestUploadDlg.vue?vue&type=script&lang=js"
export * from "./BestUploadDlg.vue?vue&type=script&lang=js"
import style0 from "./BestUploadDlg.vue?vue&type=style&index=0&id=c714a70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c714a70e",
  null
  
)

export default component.exports